import { Navbar } from "../shared/components/Navbar"
import { HeroSection } from "../shared/components/HeroSection"
import BenefitsSection from "../shared/components/BenefitsSection"
import BenefitsAndImpact from "../shared/components/BenefitsAndImpact"
import { PartnerStepsSection } from "../shared/components/PartnerStepsSection"
import { DownloadSection } from "../shared/components/DownloadSection"
import { EndorsementsSection } from "../shared/components/EndorsementsSection"
import TopShoppingNetwork from "../shared/components/TopShoppingNetwork"

export function Home() {
  return (
    <>
      <div className="sticky top-5 sm:top-0 md:relative z-50 mx-5 md:mx-7 lg:mx-10 xl:mx-[3.125rem]">
        <Navbar isHomePage />
      </div>
      <div className="h-10 -mt-10 md:h-14 md:-mt-14 -mb-1 bg-secondary mx-5 md:mx-7 lg:mx-10 xl:mx-[3.125rem] rounded-t-[1.25rem] lg:rounded-t-[1.875rem]" />
      <main className="px-5 md:px-7 lg:px-10 xl:px-[3.125rem] pb-7 md:pb-7 lg:pb-10 xl:pb-[3.125rem] overflow-hidden">
        <div className="flex flex-col gap-[3.125rem] md:gap-20 lg:gap-[6.25rem]">
          <HeroSection />
          <BenefitsSection />
          <div className="w-[6.25rem] border-b-[3px] border-softGreen mx-auto hidden md:block" />
          <BenefitsAndImpact />
          <TopShoppingNetwork />
          <EndorsementsSection />
          <PartnerStepsSection />
          <div className="w-[6.25rem] border-b-[3px] border-softGreen mx-auto hidden md:block" />
          <DownloadSection />
        </div>
      </main>
    </>
  )
}

